module.exports = __webpack_public_path__ + "img/sanyunziti.d6de4aa2.png";